<template>
  <main>
    <div class="mb-2 bg-light p-1 rounded-lg border border-light">
      <div class="text-gray-600 small font-weight-bold mb-1 d-flex align-items-center">
        <i class="fas fa-check text-gray-500 mr-2"></i> 
        <span>{{antecedente_usuario.antecedente.descripcion}}</span>
      </div>
      <div class="text-dark font-weight-400 pl-3">
        {{antecedente_usuario.valor}}
      </div>
    </div>
  </main>
</template>
<script>
export default {
    props: ['antecedente_usuario']
}
</script>
